import { render } from "./FloatingSupport.vue?vue&type=template&id=107834af&scoped=true"
import script from "./FloatingSupport.vue?vue&type=script&lang=js"
export * from "./FloatingSupport.vue?vue&type=script&lang=js"

import "./FloatingSupport.vue?vue&type=style&index=0&id=107834af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107834af"]])

export default __exports__